<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <form
                            class="form"
                            @submit.prevent="updateUser()"
                        >
                            <h4>User Details</h4>
                            <div class="form-group">
                                <label for="name">Full name:</label>
                                <input
                                    type="text"
                                    id="name"
                                    placeholder="Full name"
                                    v-model="user.name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.name }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="email">Email address:</label>
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Email address"
                                    v-model="user.email"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.email }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.email"
                                >{{ errors.email[0] }}</small>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="office_access"
                                    v-model="user.office_access"
                                    class="form-control form-check-input"
                                    value="1"
                                >
                                <label
                                    class="form-check-label"
                                    for="office_access"
                                >Office access</label>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="engineer_access"
                                    v-model="user.engineer_access"
                                    class="form-control form-check-input"
                                    value="1"
                                >
                                <label
                                    class="form-check-label"
                                    for="engineer_access"
                                >Engineer access</label>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="admin_access"
                                    v-model="user.admin_access"
                                    class="form-control form-check-input"
                                    value="1"
                                    :disabled="is_admin == 1"
                                >
                                <label
                                    class="form-check-label"
                                    for="admin_access"
                                >Admin access</label>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="receive_kpi_reports"
                                    v-model="user.receive_kpi_reports"
                                    class="form-control form-check-input"
                                    value="1"
                                >
                                <label
                                    class="form-check-label"
                                    for="receive_kpi_reports"
                                >Receive KPI Reports via Email</label>
                            </div>
                            <div class="form-group">
                                <label for="annual_leave_allowance">Annual Leave Allowance (Days):</label>
                                <input
                                    type="number"
                                    step="0.5"
                                    min="0"
                                    id="annual_leave_allowance"
                                    v-model="user.annual_leave_allowance"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.annual_leave_allowance }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.annual_leave_allowance"
                                >{{ errors.annual_leave_allowance[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="order">Order:</label>
                                <input
                                    type="number"
                                    id="order"
                                    v-model="user.order"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.order }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.order"
                                >{{ errors.order[0] }}</small>
                            </div>
                            <div>
                                <signature-upload v-model="user.signature_url" />
                                <small
                                    class="form-error"
                                    v-if="errors.order"
                                >{{ errors.signature_url[0] }}</small>
                            </div>
                            <div class="form-group">
                                <button
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    Update
                                </button>
                                <button
                                    type="button"
                                    v-if="!user.admin_access"
                                    @click="deleteUser(user)"
                                    class="btn btn-outline-danger"
                                >
                                    <i class="fa fa-times" /> Delete
                                </button>
                                <button
                                    type="button"
                                    @click="$router.go(-1)"
                                    class="btn btn-outline-secondary"
                                >
                                    Back
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <form
                            class="form"
                            @submit.prevent="changePassword()"
                        >
                            <h4>Change Password</h4>
                            <div class="form-group">
                                <label for="password">New password:</label>
                                <input
                                    type="password"
                                    id="password"
                                    placeholder="Password"
                                    v-model="password"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.password }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.password"
                                >{{ errors.password[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="password_confirmation">Confirm new password:</label>
                                <input
                                    type="password"
                                    id="password_confirmation"
                                    placeholder="Confirm password"
                                    v-model="password_confirmation"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.password_confirmation }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.password_confirmation"
                                >{{ errors.password_confirmation[0] }}</small>
                            </div>
                            <div class="form-group">
                                <button
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    Change Password
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h4>Annual Leave & Sickness</h4>
                        <events-list
                            v-if="user.id"
                            :user-id="user.id"
                            ref="eventsList"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsersService from "../../../../services/UsersService";
import SignatureUpload from '../../../SignatureUploadComponent';
import EventsList from './UserEventsList.vue';

export default {
    components: {
        SignatureUpload,
        EventsList,
    },
    data: function() {
        return {
            user: {
                name: "",
                email: "",
                office_access: false,
                engineer_access: false,
                admin_access: false,
                order: 0
            },
            password: "",
            password_confirmation: "",
            is_admin: false,
            errors: {},
            usersService: UsersService
        };
    },

    mounted: function() {
        this.usersService.get(this.$route.params.id).then(
            xhr => {
                this.user = xhr.data;
                this.is_admin = xhr.data.admin_access;
            },
            error => {
                this.$refs.ErrorModal.show(error);
            }
        );
    },

    methods: {
        updateUser: function() {
            this.errors = {};
            UsersService.update(this.user)
                .then(xhr => {
                    this.user = xhr.data;
                    this.is_admin = xhr.data.admin_access;
                    alert("User updated");
                    this.$refs.eventsList.fetchAll();
                })
                .catch(error => {
                    alert('Error: Failed to save the user');
                    this.errors = error.response.data.errors;
                });
        },
        changePassword: function() {
            this.errors = {};
            UsersService.changePassword(this.user, {
                password: this.password,
                password_confirmation: this.password_confirmation
            })
                .then(xhr => {
                    this.password = this.password_confirmation = "";
                    alert("Password updated");
                })
                .catch(error => {
                    alert('Error: Failed to change the password');
                    this.errors = error.response.data.errors;
                });
        },
        deleteUser: function(user) {
            if (confirm("Are you sure you want to delete this user?")) {
                UsersService.delete(user).then(res => {
                    alert("User deleted successfully");
                    this.$router.push({ name: "admin.users.search" });
                }, err => {
                    alert('Error: Failed to delete the user');
                    console.error(err);
                });
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/admin/users/UserEditComponent.vue